import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function InsidePages() {
  const total = pageSamples.length;
  const [index, setIndex] = useState<number>(0);
  const [direction, setDirection] = useState<number>(1);
  const goTo = (next: number) => {
    const wrapped = (next + total) % total;
    setDirection(next > index ? 1 : -1);
    setIndex(wrapped);
  };
  const page = pageSamples[index];
  return <section id="inside-pages" className="w-full bg-ink px-5 py-20 sm:py-28" data-id="element-122" data-mp="2x5m0zyxhpwtz">
      <div className="mx-auto max-w-6xl" data-id="element-123" data-mp="2x3j0um2minbj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-124" data-mp="2s5pvfv959xcb">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-125" data-mp="2s4y795hvn1w2">
            Sfoglia il materiale
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-cream sm:text-[2.8rem]" data-id="element-126" data-mp="3kuezo35hyisa">
            Guarda le pagine <span className="italic text-brand" data-id="element-127" data-mp="1mofiqrcfy5zs">dall&apos;interno.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-cream/60 sm:text-base" data-id="element-128" data-mp="1rknt7rfp1b0m">
            Pagine reali del pacchetto, dalle prime schede illustrate di 1ª Primaria alle verifiche
            della scuola media.
          </p>
        </div>

        <div role="group" aria-roledescription="carosello" aria-label="Pagine di esempio del materiale" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="mt-12 rounded-[2rem] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40" data-id="element-129" data-mp="13w4lbd0k3092">
          <div className="grid items-center gap-10 md:grid-cols-[minmax(0,1fr)_minmax(0,0.85fr)] md:gap-14" data-id="element-130" data-mp="2t8gi37qv2jx7">
            <div className="relative mx-auto w-full max-w-md md:max-w-none" data-id="element-131" data-mp="138vibisxr0s">
              <span aria-hidden="true" className="absolute -inset-3 rounded-[2rem] bg-brand/15 sm:-inset-4" data-id="element-132" data-mp="15dappm5icgd" />
              <div className="relative overflow-hidden rounded-2xl bg-white p-2 shadow-soft sm:p-3" data-id="element-133" data-mp="3o9061mxqumey">
                <AnimatePresence initial={false} mode="wait" data-id="element-134" data-mp="ors46s5rk5te">
                  <motion.img key={page.src} src={page.src} alt={`${page.title} — pagina di esempio, ${page.level}`} initial={{
                  opacity: 0,
                  x: direction * 24
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: direction * -24
                }} transition={{
                  duration: 0.25,
                  ease: EASE
                }} className="block h-auto w-full rounded-xl" data-id="element-135" data-mp="kr8a5xghlibh" />
                </AnimatePresence>
              </div>

              <button type="button" onClick={() => goTo(index - 1)} aria-label="Pagina precedente" className="absolute left-1 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-ink shadow-soft transition-[transform,background-color,color] duration-150 ease-out hover:scale-105 hover:bg-brand hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:-left-5" data-id="element-136" data-mp="1b2ti02cizy5e">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="1ywuu81eo1721" />
              </button>
              <button type="button" onClick={() => goTo(index + 1)} aria-label="Pagina successiva" className="absolute right-1 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-ink shadow-soft transition-[transform,background-color,color] duration-150 ease-out hover:scale-105 hover:bg-brand hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:-right-5" data-id="element-138" data-mp="23s0n5k6hjlzm">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="2dsi6uobr3tip" />
              </button>
            </div>

            <div className="min-w-0 text-center md:text-left" data-id="element-140" data-mp="28tezgx8atb7k">
              <AnimatePresence initial={false} mode="wait" data-id="element-141" data-mp="28w1aj6uee8uj">
                <motion.div key={page.title} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} transition={{
                duration: 0.22,
                ease: EASE
              }} data-id="element-142" data-mp="1l4md9shhahq5">
                  <span className="inline-flex items-center rounded-full bg-brand px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-143" data-mp="1q2fiojayj7pd">
                    {page.tag}
                  </span>
                  <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.16em] text-cream/45" data-id="element-144" data-mp="31i45nao7o6q6">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-2xl font-black leading-snug text-cream sm:text-3xl" data-id="element-145" data-mp="s9xzcvf5p0d0">
                    {page.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-cream/60" data-id="element-146" data-mp="ec9brftpff49">{page.caption}</p>
                </motion.div>
              </AnimatePresence>

              <p className="mt-7 font-display text-sm font-bold tabular-nums text-cream/40" data-id="element-147" data-mp="16zvhouqemvua">
                {index + 1} <span className="text-cream/20" data-id="element-148" data-mp="1azntdgb3hi3v">/</span> {total}
              </p>
            </div>
          </div>

          <ul className="mt-12 flex items-end justify-center gap-3 sm:gap-4" data-id="element-149" data-mp="x8iq848iq7os">
            {pageSamples.map((sample, sampleIndex) => {
            const isActive = sampleIndex === index;
            return <li key={sample.src} data-id="element-150" data-mp="1pvlkgk65vw98" data-mpi={sampleIndex}>
                  <button type="button" onClick={() => goTo(sampleIndex)} aria-label={`Vai alla pagina ${sampleIndex + 1}: ${sample.title}`} aria-current={isActive} className={`block overflow-hidden rounded-lg border-2 bg-white transition-[transform,border-color,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${isActive ? 'w-16 -translate-y-1 border-brand opacity-100 sm:w-20' : 'w-14 border-transparent opacity-45 hover:-translate-y-0.5 hover:opacity-80 sm:w-16'}`} data-id="element-151" data-mp="1uoepza9gf8md">
                    <img src={sample.src} alt="" loading="lazy" className="block h-auto w-full" data-id="element-152" data-mp="1bvzhf5t8xyg6" />
                  </button>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}